import {
  convertToDateFormat,
  getTimeWithTimeZone
} from '@/helpers/dateHelpers';
import { currencyFormat } from '@/helpers/stringHelpers';

import { TableCell, TableRow } from '@/components/ui/table';

import { useActivityObject } from '@/data/activity';

const OrderItemRow = ({ orderItem }) => {
  const activity = useActivityObject(orderItem.activityId);

  return (
    <TableRow>
      <TableCell>
        <span className="block">{orderItem.label}</span>
        <span className="text-xs text-muted-foreground block">
          {orderItem.locationName}
        </span>
        <span className="text-xs text-muted-foreground block">
          {activity.title}
        </span>
      </TableCell>
      <TableCell>
        <div>{orderItem.coachName}</div>
      </TableCell>
      <TableCell>
        <div>
          <span className="block">
            {convertToDateFormat(orderItem.startDateTime)}
          </span>
          <span className="block text-xs text-muted-foreground">
            {getTimeWithTimeZone(orderItem.startDateTime, orderItem.timeZone)} -{' '}
            {getTimeWithTimeZone(orderItem.endDateTime, orderItem.timeZone)}
          </span>
        </div>
      </TableCell>
      <TableCell>
        <div className="text-right">
          {orderItem.quantity} x {currencyFormat(orderItem.price)}
        </div>
      </TableCell>

      <TableCell>
        <div className="text-right">
          <span className="block">{currencyFormat(orderItem.subtotal)}</span>
          <span className="text-xs text-muted-foreground block">
            Coach Payout ({currencyFormat(orderItem.coachPayout)})
          </span>
        </div>
      </TableCell>
    </TableRow>
  );
};

export default OrderItemRow;
